'use client';

import { GaLog } from '@components/common/PageView';
import type { BrandPageServerProps } from '@models/brand';
import { getLpProductListCols } from '@wconcept/wconcept-common/utils/lpProductListCols';
import { useSearchParams } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { getBrandPageItemListParam } from '@components/pages/brand/[id]/BrandPageProductList/ga4';
import useGlobalState from '@hooks/useGlobalState';

interface BrandPageGaLogProps {
  readonly pageTitle: string;
  readonly brandInfo?: BrandPageServerProps['brandInfo'];
}

function BrandPageGaLog({ pageTitle, brandInfo }: BrandPageGaLogProps) {
  const [productPerView] = useState(() => getLpProductListCols());
  const searchParams = useSearchParams();
  const category = searchParams.get('category');
  const previousCategory = useRef(category);
  const isCategoryChanged = previousCategory.current !== category;
  const { isMobile } = useGlobalState();
  useEffect(() => {
    previousCategory.current = category;
  }, [category]);

  if (isCategoryChanged) return null;

  return (
    <GaLog
      pageTitle={pageTitle}
      params={{
        brandCd: brandInfo?.brandCd.toString(),
        brandNm: brandInfo?.brandName,
        exclusive:
          brandInfo?.exclusiveYn === 'Y' ? '브랜드' : brandInfo?.exclusiveYn,
        itemList: isMobile
          ? getBrandPageItemListParam(productPerView)
          : undefined,
      }}
    />
  );
}

export default BrandPageGaLog;
